import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Big9TopBar from '../components/big9/Big9TopBar';
import Big9Results from '../components/big9/Big9Results';
import Big9Spil from '../components/big9/Big9Spil';
import Big9Om from '../components/big9/Big9Om';
import Big9SpilClub from '../features/SpilKlub';
import Big9Tips from 'features/Big9Tips';

const BigNinePageContent = styled.section`
    min-height: 100%;
    height: auto;
    width: 100%;
    display: block;
    box-sizing: border-box;
`;

const BigNinePage = (props) => {
    const [tab, setTab] = useState(props.params.category);

    useEffect(
        () => {
            setTab(props.params.category);
        },
        [props.params.category]
    );

    const getCurrentTab = () => {
        if (tab === 'resultater') {
            return <Big9Results />;
        } else if (tab.includes('spilklub25')) {
            return (
                <Big9SpilClub
                    screen={props.params.screen}
                    entityId={props.params.entityId}
                    entityId2={props.params.entityId2}
                />
            );
        } else if (tab === 'ombig9') {
            return <Big9Om />;
        } else if (tab === 'tips') {
            return <Big9Tips />;
        } else {
            return <Big9Spil />;
        }
    };

    return (
        <BigNinePageContent>
            <Big9TopBar screen={props.params.screen} />
            {getCurrentTab()}
        </BigNinePageContent>
    );
};

export default BigNinePage;
